import {UserModel} from "./user.model";
import {Auditable} from "../shared/auditable.model";
import {HazardControlModel} from "./hazard-control.model";
import {HazardModel} from "./hazard.model";
import {FileModel} from "../shared/file.model";

export class TaskAnalysesRevisedWorkflowHazardModel extends Auditable {
  id = 0;

  name = '';

  status = 'Unverified';
  description = '';

  /**
   * Initial risk assessment
   */
  ira_likelihood: 1 | 2 | 3 | 4 | 5 = 1;
  ira_severity: 1 | 2 | 3 | 4 | 5 = 1;

  ira_score: number = 1;
  ira_score_band: 'Low' | 'Moderate' | 'High' | 'Extreme' = 'Low';

  /**
   * Residual risk assessment
   */
  rra_likelihood: 1 | 2 | 3 | 4 | 5 = 1;
  rra_severity: 1 | 2 | 3 | 4 | 5 = 1;

  rra_score: number = 1;
  rra_score_band: 'Low' | 'Moderate' | 'High' | 'Extreme' = 'Low';

  controls: HazardControlModel[] = [new HazardControlModel()];

  /**
   * Who reviewed this Hazard?
   */
  reviewer: UserModel;
  reviewer_id: number = 0;
  reviewer_date: number = 0;
  last_reviewer_date: number = 0;

  /**
   * The Reference that this Task Analysis Workflow Hazard/Risk was created from?
   */
  reference: HazardModel;
  reference_id: number = 0;

  /**
   * Files that belongs to Task Analysis Workflow Hazard/Risk?
   */
  files?: FileModel[];
  file_ids?: number[];

  /**
   * Who created this Task Analysis Workflow Hazard/Risk?
   */
  created_by_user: UserModel;

  /**
   * Who updated this Task Analysis Workflow Hazard/Risk?
   */
  updated_by_user: UserModel;

  /**
   * Used for identifying a significant hazard.
   */
  significant: boolean = false;
}
